import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import styles from './RequisitionCardActions.module.sass'
import ModalOptions from '@jimmyboys/liita-ui/dist/components/ModalOptions'
import { useReload } from 'store'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

export const RequisitionOptions = (i18n, data, showDialog, reload) => [
	[
		{
			value: 'comment',
			text: i18n`Insert comment`,
			action: () => {
				showDialog(
					'CommentDialog',
					i18n`Insert comment`,
					{
						processId: data.processId,
						requisitionId: data?.id,
					},
					false,
					undefined,
					'center',
					'comment-dialog'
				)
					.then(() => {
						reload([
							`/clinical_processes/${data.processId}/requisitions`,
							`/clinical_processes/${data?.processId}/comments`,
						])
					})
					.catch(() => null)
			},
		},
		{
			value: 'ticket',
			text: i18n`Open associated ticket`,
			action: () => {
				showDialog(
					'TicketRequestDialog',
					i18n`Ticket Request Dialog Requisition ${data.id}`,
					{
						processId: data.processId,
						requisitionId: data.id,
					},
					false,
					undefined,
					'center',
					'request-ticket-dialog'
				)
					.then(() => {
						reload([
							`/clinical_processes/${data.processId}/tickets`,
							`/clinical_processes/${data.processId}/tasks`,
						])
					})
					.catch(() => null)
			},
		},
	],
]

const RequisitionCardActions = (props) => {
	const { data, ...attributes } = props

	const { showDialog, i18n } = useGlobal()
	const reload = useReload()

	const titles = [i18n`Actions`]

	return (
		<div {...attributes} className={styles['card-actions']}>
			<ModalOptions
				className={styles['actions-modal']}
				titles={titles}
				groups={RequisitionOptions(i18n, data, showDialog, reload)}
				options={RequisitionOptions(i18n, data, showDialog, reload)}
				corner='straight'
				onSelect={(item) => {
					item && item.action && item.action()
				}}
			>
				<button className={styles['requisition-options']}>
					<Icon
						className={styles['more-icon']}
						name={'options'}
						width='20px'
						height='20px'
					/>
				</button>
			</ModalOptions>
		</div>
	)
}

export default RequisitionCardActions
